var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"justify-center body-1 primary pa-1",domProps:{"textContent":_vm._s('Locals')}}),_c('v-card-text',[_c('input_table',{attrs:{"info_table":_vm.info_to_table,"list_table":_vm.list_to_table}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }